export interface OperationResponse<T> {
  data?: T
  Data?: T
  message?: string
  Message?: string
  errors?: Record<string, string | string[]>
}

export function unwrapOperationResponse<T>(value: T | OperationResponse<T>): T {
  if (value && typeof value === 'object') {
    const envelope = value as OperationResponse<T>
    if (envelope.data !== undefined) return envelope.data
    if (envelope.Data !== undefined) return envelope.Data
  }
  return value as T
}
